import AddNumber from "./add-number/AddNumber";
import AddMail from "./add-mail/AddMail";
import AddPassword from "./add-password/AddPassword";
// import AddPayment from "./addPayment/AddPayment";
import AddAddress from "./add-adress/AddAddress";
// import Notifications from "./notifications/Notifications";
// import AddName from "./add-name/AddName";
import "./Settings.scss";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { fetchUserInfo } from "../../../redux/slices/user";

const Settings = () => {
  const dispatch = useDispatch();
  const { user } = useSelector(state => state.user);

  useEffect(() => {
    dispatch(fetchUserInfo());
  }, [dispatch]);

  return (
    <section className="setting">
      <div>Данные для входа:</div>
      <div className="setting__data">
        {/* <AddName /> */}
        <AddNumber userData={user} />
        <AddMail userData={user} />
        <AddPassword userData={user} />
      </div>
      {/* <AddPayment /> */}
      {/* <AddAddress userData={user} /> */}
      {/* <div>
        <Notifications />
      </div> */}
    </section>
  );
};

export default Settings;
